import { ITrainingPersonValues } from './training-person-form-types'
import { ITrainingPerson, ITrainingPersonUpsert } from '../../../../interfaces'

export const getTrainingPersonEndDate = (trainingPerson: ITrainingPerson): string | undefined =>
  trainingPerson.employmentPeriods
    ?.filter(period => period.endDate)
    .sort((a, b) => (a.endDate! < b.endDate! ? 1 : -1))[0]?.endDate

export const trainingPersonToTrainingPersonValues = (
  trainingPerson: ITrainingPerson | undefined,
): ITrainingPersonValues | undefined => {
  if (!trainingPerson) {
    return undefined
  }

  return {
    firstName: trainingPerson?.firstName,
    lastName: trainingPerson?.lastName,
    email: trainingPerson?.email,
    phone: trainingPerson?.phone,
    hireDate: trainingPerson?.hireDate,
    // not submitted -- seeds allValues.endDate so the hireDate field can validate against it
    endDate: getTrainingPersonEndDate(trainingPerson),
    trainingGroupIds: trainingPerson?.trainingGroups.map(group => group.id) ?? [],
    authUserId: trainingPerson?.authUser?.id,
  }
}

export const trainingPersonValuesToTrainingPersonAddUpsert = (
  trainingPersonValues: ITrainingPersonValues,
): ITrainingPersonUpsert | undefined => {
  if (!trainingPersonValues) {
    return undefined
  }

  return {
    firstName: trainingPersonValues?.firstName,
    lastName: trainingPersonValues?.lastName,
    email: trainingPersonValues?.email,
    phone: trainingPersonValues?.phone,
    hireDate: trainingPersonValues?.hireDate,
    trainingGroupIds: trainingPersonValues?.trainingGroupIds ?? [],
    authUserId: trainingPersonValues?.authUserId,
  }
}

export const trainingPersonValuesToTrainingPersonUpdateUpsert = (
  trainingPersonValues: ITrainingPersonValues,
  trainingPerson: ITrainingPerson,
): ITrainingPersonUpsert | undefined => {
  if (!trainingPersonValues || !trainingPerson?.id) {
    return undefined
  }

  return {
    id: trainingPerson.id,
    firstName: trainingPersonValues?.firstName,
    lastName: trainingPersonValues?.lastName,
    email: trainingPersonValues?.email,
    phone: trainingPersonValues?.phone,
    hireDate: trainingPersonValues?.hireDate,
    trainingGroupIds: trainingPersonValues?.trainingGroupIds ?? [],
    authUserId: trainingPersonValues?.authUserId,
  }
}
